<mat-card appearance="outlined" class="syncing-progress-summary-card flex-1">
  <ng-container>
    <mat-card-header class="syncing-progress-summary-card-title">
      <mat-card-title>
        {{ 'LISTING_SYNC.SYNCING_PROGRESS_SUMMARY_CARD.TITLE' | translate }}
      </mat-card-title>
      <span>
        <mat-icon
          class="tool-tip"
          [glxyPopover]="syncingProgressPopover"
          (mouseenter)="showPopovers()"
          (mouseleave)="hidePopovers()"
        >
          info_outline
        </mat-icon>
        <glxy-popover
          #syncingProgressPopover
          [isOpen]="showPopover"
          [positions]="[PopoverPositions.Bottom]"
          maxWidth="500px"
        >
          <div class="legend" *ngFor="let statusLegend of syncingProgressLegendConfig">
            <div>
              <span>
                <mat-icon [ngClass]="statusLegend.style + '-icon'">{{ statusLegend.icon }}</mat-icon>
              </span>
              <span [ngClass]="statusLegend.style + '-text'">{{ statusLegend.name | translate }}</span>
              <span>|</span>
              <span>{{ statusLegend.description | translate }}</span>
            </div>
          </div>
        </glxy-popover>
      </span>
    </mat-card-header>
    <mat-card-content
      *ngIf="summaryData$ | async as data; else loading"
      class="syncing-progress-summary-card-content-container"
    >
      <div class="syncing-progress-summary-card-content">
        <div class="x-of-y-container">
          <div class="x-of-y-value" [ngClass]="getSyncValueBgColor(data)">
            {{ data.syncedSourcesCount || 0 }}/{{ data.totalSourcesCount }}
          </div>
        </div>
        <local-seo-listings-summary-card [data]="data"></local-seo-listings-summary-card>
      </div>
    </mat-card-content>
  </ng-container>
  <ng-template #loading>
    <div class="loading-spinner-wrapper">
      <glxy-loading-spinner></glxy-loading-spinner>
    </div>
  </ng-template>
</mat-card>
